<template>
  <v-row dense>
    <v-col cols="12" :sm="fullWidth ? '12' : '4'">
      <span class="caption font-weight-bold">Conta contábil</span>
      <div :class="`${textClass}`">
        {{ formData.CONTA_CONTABIL | truncate(45) }}
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    textClass: {
      type: String,
      default: '',
    },
  },
};
</script>
